import * as React from 'react';
import * as ReactDom from 'react-dom';
const TOP_NAVBAR_PORTAL_ID = 'menu-portal';
const AUTO_MAKER_LOGO_PORTAL_ID = 'automaker-logo-portal';

export const TopNavbarPortal: React.FC = () => {
  return <div id={TOP_NAVBAR_PORTAL_ID} className='w-100'></div>;
};

export const DynamicTopNavbarPortal: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [element, setElement] = React.useState(
    document.getElementById(TOP_NAVBAR_PORTAL_ID),
  );
  React.useEffect(() => {
    setElement(document.getElementById(TOP_NAVBAR_PORTAL_ID));
  }, []);
  return (
    <React.Fragment>
      {element && ReactDom.createPortal(children, element)}
    </React.Fragment>
  );
};

export const AutomakerLogoHolder: React.FC = () => {
  return <div id={AUTO_MAKER_LOGO_PORTAL_ID}></div>;
};

export const AutomakerLogoPortal: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [element, setElement] = React.useState(
    document.getElementById(AUTO_MAKER_LOGO_PORTAL_ID),
  );
  React.useEffect(() => {
    setElement(document.getElementById(AUTO_MAKER_LOGO_PORTAL_ID));
  }, []);
  return (
    <React.Fragment>
      {element && ReactDom.createPortal(children, element)}
    </React.Fragment>
  );
};
